import React from "react";
import Joi from "joi-browser";
import Button from "react-bootstrap/Button";
import Dots from "react-activity/lib/Dots";
import { withRouter } from "react-router-dom";
import FormState from "./common/formstate";
import { getList } from "../services/manufacturerService";
import { getAircraftGroups } from "../services/aircraftGroupService";
import { getMediaList } from "../services/mediaService";
import { getScales } from "../services/scaleService";
import { getAircraftYears } from "../services/aircraftService";
import { getCountriesOfManufacturer } from "../services/aircraftService";
import { getKitMolds } from "../services/aircraftModelsService";

class SearchAircraft extends FormState {
  state = {
    data: {
      aircraft_name: "",
      year_of_manufacture: 0,
      country_of_manufacturer: "",
      manufacturer_id: 0,
      primary_group_id: 0,
      media_id: 0,
      scale_id: 0,
      kit_mold: "",
      kit_no: "",
    },
    manufacturers: [],
    aircraftGroups: [],
    media: [],
    scales: [],
    years: [],
    countries: [],
    kit_molds: [],
    errors: {},
    stateData: false,
    loaded: true,
  };

  schema = {
    aircraft_name: Joi.string().label("Aircraft Name").optional().allow(""),
    manufacturer_id: Joi.string().label("Manufacturer").optional().allow(""),
    primary_group_id: Joi.string().label("Aircraft Type").optional().allow(""),
    media_id: Joi.string().label("Model Media").optional().allow(""),
    scale_id: Joi.number().label("Scale Range").optional().allow(""),
    year_of_manufacture: Joi.number()
      .label("Year Of Manufacture")
      .optional()
      .allow(""),
    country_of_manufacturer: Joi.string()
      .label("Country of Manufacturer")
      .optional()
      .allow(""),
    kit_mold: Joi.string().label("Kit Mold").optional().allow(""),
    kit_no: Joi.string().label("Kit No.").optional().allow(""),
  };

  async populateLists() {
    const manufacturers = await getList();
    const aircraftGroups = await getAircraftGroups();
    const media = await getMediaList();
    const scales = await getScales();
    const years = await getAircraftYears();
    const countries = await getCountriesOfManufacturer();
    const kit_molds = await getKitMolds();
    this.setState({
      manufacturers,
      aircraftGroups,
      media,
      scales,
      years,
      countries,
      kit_molds,
    });
  }

  async componentDidMount() {
    this.setState({ loaded: false });
    await this.populateLists();
    this.getlocalStorage();
    this.setState({ loaded: true });
  }

  getlocalStorage() {
    const searchData = {};

    searchData.aircraft_name = localStorage.getItem("a_aircraft_name");
    searchData.manufacturer_id = localStorage.getItem("a_manufacturer_id");
    searchData.media_id = localStorage.getItem("a_media_id");
    searchData.scale_id = localStorage.getItem("a_scale_id");
    searchData.country_of_manufacturer = localStorage.getItem(
      "a_country_of_manufacturer"
    );
    searchData.primary_group_id = localStorage.getItem("a_primary_group_id");
    searchData.year_of_manufacture = localStorage.getItem(
      "a_year_of_manufacture"
    );
    searchData.kit_mold = localStorage.getItem("a_kit_mold");
    searchData.kit_no = localStorage.getItem("a_kit_no");

    this.setState({ data: searchData });
  }

  setLocalStorage() {
    const { data: searchData } = this.state;

    localStorage.setItem("a_aircraft_name", searchData.aircraft_name || "");
    localStorage.setItem(
      "a_manufacturer_id",
      searchData.manufacturer_id || "0"
    );
    localStorage.setItem("a_media_id", searchData.media_id || "0");
    localStorage.setItem("a_scale_id", searchData.scale_id || "0");
    localStorage.setItem(
      "a_country_of_manufacturer",
      searchData.country_of_manufacturer || ""
    );
    localStorage.setItem(
      "a_primary_group_id",
      searchData.primary_group_id || "0"
    );
    localStorage.setItem(
      "a_year_of_manufacture",
      searchData.year_of_manufacture || "0"
    );
    localStorage.setItem("a_kit_mold", searchData.kit_mold || "");
    localStorage.setItem("a_kit_no", searchData.no || "");
    localStorage.setItem("a_currentPage", "1");
    localStorage.setItem("a_pageSize", "10");
  }

  clearForm() {
    localStorage.setItem("a_aircraft_name", "");
    localStorage.setItem("a_manufacturer_id", "0");
    localStorage.setItem("a_media_id", "0");
    localStorage.setItem("a_scale_id", "0");
    localStorage.setItem("a_country_of_manufacturer", "");
    localStorage.setItem("a_primary_group_id", "0");
    localStorage.setItem("a_year_of_manufacture", "0");
    localStorage.setItem("a_kit_mold", "");
    localStorage.setItem("a_kit_no", "");
    localStorage.setItem("a_currentPage", "1");
    localStorage.setItem("a_pageSize", "10");

    this.getlocalStorage();
  }

  handleSearchFormSubmit = (e) => {
    e.preventDefault();
    this.setLocalStorage();
    this.props.history.push("/aircraft/results");
  };

  onInputChange(input) {
    this.props.onInputChange(input);
  }

  render() {
    const { loaded } = this.state;

    return loaded === false ? (
      <div className="dots_loader">
        <Dots size={26} />
      </div>
    ) : (
      <div>
        <form onSubmit={this.handleSearchFormSubmit}>
          <table className="searchTable">
            <tbody>
              <tr>
                <td>
                  {this.renderInput(
                    "aircraft_name",
                    "Aircraft Name",
                    "pencil-alt"
                  )}
                </td>
                <td>
                  {this.renderSelect(
                    "primary_group_id",
                    "Aircraft Type",
                    this.state.aircraftGroups,
                    "group_id",
                    "group_name",
                    "plane"
                  )}
                </td>
              </tr>
              <tr>
                <td>
                  {this.renderSelect(
                    "year_of_manufacture",
                    "Year Of Manufacture",
                    this.state.years,
                    "year_of_manufacture",
                    "year_of_manufacture",
                    "calendar-alt"
                  )}
                </td>
                <td>
                  {this.renderSelect(
                    "media_id",
                    "Model Media",
                    this.state.media,
                    "media_id",
                    "media_name",
                    "dna"
                  )}
                </td>
              </tr>
              <tr>
                <td>
                  {this.renderSelect(
                    "country_of_manufacturer",
                    "Country Of Manufacturer",
                    this.state.countries,
                    "country_of_manufacturer",
                    "country_of_manufacturer",
                    "flag-usa"
                  )}
                </td>
                <td>
                  {this.renderSelect(
                    "scale_id",
                    "Scale Range",
                    this.state.scales,
                    "scale_id",
                    "scale_range",
                    "balance-scale-right"
                  )}
                </td>
              </tr>
              <tr>
                <td>
                  {this.renderSelect(
                    "kit_mold",
                    "Kit Mold",
                    this.state.kit_molds,
                    "kit_mold",
                    "kit_mold",
                    "hard-hat"
                  )}
                </td>
                <td>
                  {this.renderSelect(
                    "manufacturer_id",
                    "Brand",
                    this.state.manufacturers,
                    "manufacturer_id",
                    "manufacturer_fullname",
                    "tools"
                  )}
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  {this.renderInput("kit_no", "Kit No.", "pencil-alt")}
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <button className="btn btn-primary">Search</button>&nbsp;
                  <Button variant="primary" onClick={() => this.clearForm()}>
                    Clear
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    );
  }
}

export default withRouter(SearchAircraft);
